import React from 'react'
import { useParams } from 'react-router-dom'
import ServiceMainScreen from '../../components/ServiceMainScreen/ServiceMainScreen'
import TableBlock from '../../components/TableBlock/TableBlock'
import TextBlocksBlock from '../../components/TextBlocksBlock/TextBlocksBlock'
import QuestionBlock from '../../components/QuestionBlock/QuestionBlock'
import InfoBlock from '../../components/InfoBlock/InfoBlock'
import StageBlock from '../../components/StageBlock/StageBlock'
import WorkSubServiceBlock from '../../components/WorkSubServiceBlock/WorkSubServiceBlock'
import { useSubServiceData } from '../../hooks/useSubServiceData'

const SubService = () => {
  const { slug, subSlug } = useParams()
  const { data: subService, isLoading } = useSubServiceData(slug, subSlug)
  const faq = subService?.faq
    ? [...subService.faq].sort((a, b) => a.order - b.order)
    : []

  return (
    <>
      <ServiceMainScreen isSubService />
      <InfoBlock />
      <TableBlock />
      <TextBlocksBlock />
      <StageBlock />
      <WorkSubServiceBlock />
      <QuestionBlock items={faq} isLoading={isLoading} ariaLabel="Часто задаваемые вопросы по подуслуге" />
    </>
  )
}

export default SubService
